jQuery(document).ready(function () {
    var video = $('.pd-video').children('.pd-video__video')[0];
    video.pause();
    var videoAdn = $('.pd-video__video.adn').get(0);
    videoAdn.pause();
    var videoAdnBox = $('.pd-video__video.adn-box').get(0);
    videoAdn.pause();

    $('.ver-video-button, .vervideo-img .main.responsive, .watch-video').click(function () {
        $('.video-wrapper').css('display', 'block');
    });

    $('.video-popup-overlay, .close-popup-icon').click(function () {
        $('.video-wrapper').css('display', 'none');
        video.pause();
    });

    $('.video-popup-overlay.adn').click(function (e) {
        e.preventDefault();
        $('.video-wrapper').css('display', 'none');
        videoAdn.pause();
    });

    $('.video-popup-overlay.adn-box').click(function (e) {
        e.preventDefault();
        $('.video-wrapper').css('display', 'none');
        videoAdnBox.pause();
    });

    /// POP-UP///

    $('.btn-test-start').click(function () {
        $('.start-test-modal').css('display', 'flex');
    });

    $('.close').click(function () {
        $('.start-test-modal').css('display', 'none');
    });
});
